import { render, staticRenderFns } from "./VerticalSlide.vue?vue&type=template&id=45af806d&"
import script from "./VerticalSlide.vue?vue&type=script&lang=js&"
export * from "./VerticalSlide.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlide.vue?vue&type=style&index=0&id=45af806d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports